import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M9.513 6v3a.5.5 0 0 1-1 0V6a.5.5 0 0 1 1 0m-3.71-2.641L7.34 8.873a.494.494 0 0 1-.953.267L6.065 8H3.462L3.14 9.14a.494.494 0 0 1-.952-.267l1.545-5.554c.07-.304.27-.56.55-.703a1.07 1.07 0 0 1 .919-.025c.293.123.518.409.602.768M5.783 7l-.965-3.417c-.014-.058-.095-.058-.11 0L3.745 7zm5.73-2a.5.5 0 0 0-.5.5v4c0 .827-.672 1.5-1.5 1.5h-7c-.827 0-1.5-.673-1.5-1.5v-7c0-.827.673-1.5 1.5-1.5h4a.5.5 0 0 0 0-1h-4a2.503 2.503 0 0 0-2.5 2.5v7c0 1.379 1.122 2.5 2.5 2.5h7c1.379 0 2.5-1.121 2.5-2.5v-4a.5.5 0 0 0-.5-.5M8.09 2.59l.934.393.372.933a.53.53 0 0 0 .987 0l.37-.927.928-.37a.53.53 0 0 0 0-.988l-.927-.37-.37-.927a.534.534 0 0 0-.988 0l-.369.922-.92.348a.532.532 0 0 0-.018.986"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }